<div class="camera-container">

  <button class="close-btn" (click)="close()">✕</button>

  <div class="camera-view">
    <webcam
      class="camera"
      [trigger]="triggerObservable"
      (imageCapture)="handleImage($event)"
      mirrorImage="never"
      [allowCameraSwitch]="true"
      (initError)=" this.initError.emit($event)"
      >
    </webcam>
  </div>


  <div class="carousel" *ngIf="photos.length">
    <div class="thumb" *ngFor="let photo of photos; let i = index">
      <img [src]="photo">
      <button class="delete" (click)="removePhoto(i)">✕</button>
    </div>
  </div>

  <div class="controls">
    <ng-container>
      <button *ngIf="maxPhotos == null || maxPhotos > photos.length"  class="capture-btn" (click)="takePhoto()">
        <span *ngIf="maxPhotos != null"> {{maxPhotos - photos.length}}</span>
      </button>
      <button *ngIf="photos.length" class="done-btn" (click)="done()">Done</button>
    </ng-container>
  </div>

</div>